import { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Role context
export const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
    const [role, setRole] = useState(() => {
        return sessionStorage.getItem('role') || null;
    });

    useEffect(() => {
        if (role) {
            sessionStorage.setItem('role', role);
        } else {
            sessionStorage.removeItem('role');
        }
    }, [role]);

    return (
        <RoleContext.Provider value={{ role, setRole }}>{children}</RoleContext.Provider>
    );
};

export const useRole = () => {
    return useContext(RoleContext);
};

RoleProvider.propTypes = {
    children: PropTypes.node.isRequired
};
